export {AppConfigsServiceProvider, useAppConfigsService, useAppConfigQuery} from './app-configs-service-provider'
